import React, { useSyncExternalStore } from 'react';
import { RiWifiOffLine } from 'react-icons/ri';

/**
 * KD3 S2411 (FLOW-QUOT-011): query ทุกตัวใช้ networkMode 'online' (queryClient.ts) — ตอนเน็ตหลุด React Query
 * "พัก" การดึงข้อมูลเงียบ ๆ: กดรีเฟรช/เปลี่ยนตัวกรองแล้วไม่มี request ไม่มี error ไม่มีแบนเนอร์ ตารางยังโชว์ข้อมูลเก่า
 * เหมือนไม่มีอะไรผิด · ไม่เปลี่ยน networkMode เป็น 'always' เพราะ dashboard poll ทุก 30–60 วิ จะ error ถี่ตลอดช่วงออฟไลน์
 * → บอกผู้ใช้ที่จุดเดียวทุกหน้าแทน (พอกลับออนไลน์ query ที่พักไว้ยิงต่อเองแล้วแถบหายเอง)
 */
const subscribe = (onChange: () => void) => {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
};

export const OfflineBanner: React.FC = () => {
  const online = useSyncExternalStore(subscribe, () => navigator.onLine, () => true);
  if (online) return null;
  return (
    <div role="status" aria-live="polite" className="mb-4 flex items-start gap-2 rounded-lg border border-warning-300 bg-warning-50 px-4 py-3 text-sm text-warning-800">
      <RiWifiOffLine className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden="true" />
      <span>
        ไม่ได้เชื่อมต่ออินเทอร์เน็ต — ข้อมูลที่เห็นอาจไม่ใช่ข้อมูลล่าสุด และจะโหลดใหม่อัตโนมัติเมื่อกลับมาออนไลน์
      </span>
    </div>
  );
};

export default OfflineBanner;
